module.exports = __webpack_public_path__ + "static/media/header_bg.9b1f8e05.png";